import { FaPhoneAlt, FaLocationArrow, FaGithub, FaFire, FaReact, FaPython, FaJs, FaHeadSideVirus, FaNodeJs, FaHtml5, FaCss3, FaBootstrap, FaSass, FaEnvelope } from 'react-icons/fa';
import image from '../../images/person-gify.gif';
import { Slide } from "react-awesome-reveal";
import '../UI/css/about.css';
const About = () => {
    return (
        <div id="about">
            <div className="container my-5">
                <div className="row container text-white">
                    <div className="col-12 col-sm-12 col-md-4 about-image">
                        <Slide direction='left'>
                            <img src={image} alt="about-me" className='rounded mb-4 mb-md-0' />
                        </Slide>
                    </div>

                    <div className="col-12 col-sm-12 col-md-8 about-desc">
                        <Slide direction='right'>
                            <h1 className="text-white">ABOUT ME</h1>
                            <hr />
                            <h2>FRONT-END WEB DEVELOPER</h2>
                            <p className="">A self-motivated, energetic, and passionate professional web Development with valuable experience in React, TypeScript, MaterialUi and Angular Js.I enjoy turning complex problems into simple, beautiful, and intuitive interface designs</p>
                            <div className="row about-name">
                                <div className="col-md-6">
                                    <p><FaHeadSideVirus /> Bechelors In Science</p>
                                    <p><FaEnvelope /> ujjalzaman@gmail.com</p>
                                </div>
                                <div className="col-md-6">
                                    <p><FaPhoneAlt /> +8801751040425</p>
                                    <p><FaLocationArrow /> Moulvibazar, Bangladesh</p>
                                </div>
                            </div>
                            <div className="tech-icon">
                                <FaReact className="about-icon" />
                                <FaJs className="about-icon" />
                                <FaNodeJs className="about-icon" />
                                <FaBootstrap className="about-icon" />
                                <FaPython className="about-icon" />
                                <FaHtml5 className="about-icon" />
                                <FaCss3 className="about-icon" />
                                <FaGithub className="about-icon" />
                                <FaFire className="about-icon" />
                                <FaSass className="about-icon" />
                            </div>
                        </Slide>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;


